<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="affectedModal" tabindex="-1" role="dialog" aria-labelledby="affectedModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5><b>Affected {{ type }}s</b></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table v-if="type=='node'"  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Node Name</b></th>
                <th><b>Total Outages</b></th>

              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in nodesData" :key="index">
                <td></td>
                <td>{{row.id}}</td>
                <td>{{row.count}}</td>
              </tr>
              </tbody>
            </table>
            <table v-else  class="table table-striped single-outage-table">
              <thead>
              <tr class="text-center">
                <th></th>
                <th><b>Rack</b></th>
                <th><b>Nodes</b></th>
                <th><b>Total Outages</b></th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-center" v-for="(row, index) in (racksData)" :key="index">
                <td></td>
                <td>{{row.id}}</td>
                <td>{{row.nodes.toString()}}</td>
                <td>{{row.count}}</td>
              </tr>
              </tbody>
            </table>

          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "affectedNodesAndRacks",
  data(){
    return {
      nodesData: [],
      racksData: [],
      type: ''
    }
  },
  methods: {
    async load(dataArray, nodes, type){
      this.type=type
      this.nodesData=[]
      this.racksData=[]
      console.log('data', dataArray)
      if(type==='node'){
        dataArray.map(el => {
          this.nodesData.push({id: el.id, count: el.count, ...nodes[`${el.id}`]})
        })
      } else {
        const groupedRacks = {};
        // dataArray.forEach((item) => {
        //   const rackName = item.id
        //   if (!rackName) return
        //   if (!groupedRacks[rackName]) {
        //     groupedRacks[rackName] = { name: rackName, count: item.count }
        //   } else {
        //     groupedRacks[rackName].count += item.count
        //   }
        // });
        this.racksData = dataArray.filter(el => el)
      }
      $('#affectedModal').modal('show');
    }
  }
}
</script>

<style scoped>

</style>
